import { setViewModel } from './faqSlice';
import { AnyAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';
import i18n from '../../i18n/config';

import { NavigateParams } from '../../components/BtNavigate';
import { LoadingParams } from '../../components/BtLoading';


export function none(): FaqScreen.None {
    return {
        type: 'none',
        texts: {
            title: '',
            back: '',
            home: '',
            faq: '',
            support: '',
            booking: '',
            q1: '',
            a1: '',
            q2: '',
            a2: '',
            q3: '',
            a3: '',
            metaTitle: '',
            loading: ''
        },
        loading: {
            title: '', navigation: {
                back: { title: '', image: 'ico_back_arrow', visible: false },
                home: { title: '', image: 'ico_home', visible: false },
                image: 'logo_assistansbolaget',
            },
        },
    }
}

export namespace FaqScreen {

    interface Texts {
        title: string
        back: string
        home: string
        booking: string
        faq: string
        support: string
        q1: string
        a1: string
        q2: string
        a2: string
        q3: string
        a3: string
        metaTitle: string
        loading: string
    }

    interface FAQ {
        title: string,
        body: string
    }

    export interface None {
        type: 'none'
        texts: Texts
        loading: LoadingParams
    }

    export interface Loading {
        type: 'loading'
        texts: Texts
        loading: LoadingParams
    }

    export interface Ready {
        type: 'ready'
        texts: Texts
        navigation: NavigateParams
        greeting: string
        imageUp: string
        imageDown: string
        items: FAQ[]
        metaTitle: string
    }

    export type ViewModel = None | Loading | Ready

    export function isNone(viewModel: ViewModel): viewModel is None {
        return (viewModel as None).type === 'none';
    }
    export function isLoading(viewModel: ViewModel): viewModel is Loading {
        return (viewModel as Loading).type === 'loading';
    }
    export function isReady(viewModel: ViewModel): viewModel is Ready {
        return (viewModel as Ready).type === 'ready';
    }

    function getTexts(viewModel: ViewModel): Texts {
        if (isNone(viewModel)) return viewModel.texts
        if (isLoading(viewModel)) return viewModel.texts
        if (isReady(viewModel)) return viewModel.texts
        return { title: '', home: '', back: '', booking: '', faq: '', support: '', q1: '', a1: '', q2: '', a2: '', q3: '', a3: '', metaTitle: '', loading: ''}
    }



    function loading(viewModel: ViewModel): Loading {
        const t = i18n.t;
        return {
            type: 'loading',
            texts: {
                title: t('faqScreen.title'),
                back: t('faqScreen.back'),
                home: t('faqScreen.home'),
                booking: t('navigation.booking'),
                faq: t('navigation.faq'),
                support: t('navigation.support'),
                q1: t('faqScreen.q1'),
                a1: t('faqScreen.a1'),
                q2: t('faqScreen.q2'),
                a2: t('faqScreen.a2'),
                q3: t('faqScreen.q3'),
                a3: t('faqScreen.a3'),
                metaTitle: t('faqScreen.metaTitle'),
                loading: t('loading.title'),
            },
            loading: {
                title: t('loading.title'), navigation: {
                    back: { title: '', image: 'ico_back_arrow', visible: false },
                    home: { title: '', image: 'ico_home', visible: false },
                    image: 'logo_assistansbolaget',
                },
            },
        }
    }

    function ready(viewModel: ViewModel): Ready {
        const texts = getTexts(viewModel)
        return {
            type: 'ready',
            texts: texts,
            greeting: texts.title,
            navigation: {
                back: { title: '', image: 'ico_back_arrow', visible: true },
                home: { title: '', image: 'ico_home', visible: true },
                image: '',
            },
            imageUp: 'ico_chevron_up',
            imageDown: 'ico_chevron_down',
            items: [{ title: texts.q1, body: texts.a1 }, { title: texts.q2, body: texts.a2 }, { title: texts.q3, body: texts.a3 }],
            metaTitle: texts.metaTitle,
        }
    }

    export function start(viewModel: ViewModel): ((dispatch: Dispatch<AnyAction>) => void) {
        return dispatch => {
            dispatch(setViewModel(loading(viewModel)));
        };
    }

    export async function load(viewModel: ViewModel): Promise<((dispatch: Dispatch<AnyAction>) => void)> {
        return dispatch => {
            dispatch(setViewModel(ready(viewModel)));
        };
    }
}

